import { render, staticRenderFns } from "./BankConnectionFlow.vue?vue&type=template&id=3f985a8e&scoped=true&"
import script from "./BankConnectionFlow.vue?vue&type=script&lang=js&"
export * from "./BankConnectionFlow.vue?vue&type=script&lang=js&"
import style0 from "./BankConnectionFlow.vue?vue&type=style&index=0&id=3f985a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f985a8e",
  null
  
)

export default component.exports